/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseError } from './Errors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const wrapIntoErrorObject = function (e: unknown): BaseError {
	if (!e) {
		return new BaseError('Unspecified error');
	} else if (e instanceof BaseError) {
		return e;
	} else if (e instanceof Error) {
		return new BaseError(e.message);
	} else if (typeof e === 'string' || e instanceof String) {
		return new BaseError(e.toString());
	} else if (typeof e === 'number' || e instanceof Number) {
		return new BaseError(`Error code ${e}`);
	} else if (typeof e === 'boolean' || e instanceof Boolean) {
		return new BaseError(`Error with attribute ${e}`);
	} else {
		// What the heck is this error then?
		throw e;
	}
};
